import styled, { css } from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

const NARROW = "599px";

export const Card = styled.div`
    background: ${colors.surface};
    border-radius: ${radii.base};
    box-shadow: ${shadows.panel};
    overflow: hidden;
`;

const line = css`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 11px 20px;

    @media (max-width: ${NARROW}) {
        gap: 12px;
        padding: 10px 14px;
    }
`;

export const IndicatorCell = styled.div`
    flex: none;
    width: 8px;
    display: flex;
    align-items: center;
`;

export const Main = styled.div<{ $width?: number }>`
    flex: ${({ $width }) => ($width ? `0 0 ${$width}px` : "1 1 auto")};
    min-width: 0;

    @media (max-width: ${NARROW}) {
        flex: 1 1 auto;
    }
`;

export const Primary = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: ${colors.textPrimary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Meta = styled.div`
    display: none;

    @media (max-width: ${NARROW}) {
        display: block;
        margin-top: 2px;
        font-size: 12px;
        color: ${colors.textSecondary};
    }
`;

export const Cell = styled.div<{ $width?: number; $grow?: boolean; $align?: "left" | "right" }>`
    flex: ${({ $grow }) => ($grow ? "1 1 0" : "none")};
    min-width: 0;
    width: ${({ $width }) => ($width ? `${$width}px` : "auto")};
    text-align: ${({ $align }) => $align || "left"};
    font-size: 14px;
    color: ${colors.textSecondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: ${NARROW}) {
        display: none;
    }
`;

export const ActionCell = styled.div<{ $width?: number }>`
    flex: none;
    width: ${({ $width }) => ($width ? `${$width}px` : "auto")};
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${NARROW}) {
        width: auto;
    }
`;

/*
* Заголовки колонок оформляет шапка, а не пропы ячеек: шапка и строки делят одну разметку,
* и различаться должен только текст. Селектор по потомкам, а не по компонентам кита
* (${Cell}) — те требуют babel-плагина styled-components, которого в проекте нет.
* */
export const HeaderRow = styled.div`
    ${line}
    padding: 10px 20px;
    background: rgba(0, 0, 0, 0.02);
    border-bottom: 1px solid ${colors.borderSofter};

    div {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: ${colors.textSecondary};
    }

    @media (max-width: ${NARROW}) {
        display: none;
    }
`;

export const Row = styled.div<{ $clickable: boolean }>`
    ${line}
    border-bottom: 1px solid ${colors.borderSofter};
    cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};

    &:hover {
        background: rgba(0, 0, 0, 0.02);
    }

    &:focus-visible {
        outline: none;
        background: ${colors.infoBg};
    }
`;
